import { useEffect } from 'react';
import useDesignAccess from '@pkg/access/designs/useAccess';
import useAuthStore from '@pkg/auth/useStore';
import useDesignStore from './useDesignStore';

export default function useAccess() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const design = useDesignStore((state) => state.design);
  const isError = useDesignStore((state) => state.isError);
  const isHistorical = useDesignStore((state) => state.isHistorical);
  const editModeEnabled = useDesignStore((state) => state.editModeEnabled);
  const snapshot = useDesignStore((state) => state.revision?.snapshot);
  const set = useDesignStore((state) => state.set);
  const access = useDesignAccess(design, snapshot, isHistorical);

  useEffect(() => {
    set({ access });
  }, [access]);

  useEffect(() => {
    const isPublic = !isAuthenticated;
    const isReadOnly = !editModeEnabled || isPublic || isError || isHistorical;
    set({ isPublic, isReadOnly });
  }, [isAuthenticated, isError, isHistorical, editModeEnabled]);
}
